import React from "react";
import {
  CardContent,
  Typography,
  Box
} from "@mui/material";
import { StyledCard, StatusChip,  } from "./styled";

const CollectionResultsCard = ({ result }) => {
  if (!result) {
    return null;
  }

  return (
    <StyledCard>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Collection Results
        </Typography>

        <Box sx={{ mb: 2 }}>
          <StatusChip
            label={`Status: ${result.result}`}
            color={result.result === "success" ? "success" : "error"}
          />
          <StatusChip label={`Environment: ${result.environment}`} color="info" />
          <StatusChip label={`Found: ${result.establishments_found}`} color="success" />
          <StatusChip label={`Location: ${result.location}`} color="default" />
        </Box>

        {result.data_cleared && (
          <Box sx={{ mb: 2, p: 2, bgcolor: "warning.light", borderRadius: 1 }}>
            <Typography variant="body2" color="textSecondary">
              <strong>Data Cleared:</strong> {result.data_cleared.message}
            </Typography>
          </Box>
        )}

        <Typography variant="body1" sx={{ mb: 2 }}>
          <strong>Message:</strong> {result.message}
        </Typography>

        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          <strong>Coordinates:</strong> {result.coordinates?.lat}, {result.coordinates?.lng}
        </Typography>
      </CardContent>
    </StyledCard>
  );
};

export default CollectionResultsCard;
